import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import ResponseEntity from '../../../store/polls-store/response-entity';
import { calculatePollPercentages, sortByOrder } from '../../../utils/helpers/polls-helper';
import PollResponseVotes from '../poll-details/poll-details-components/poll-details-response';

interface IProps {
    responses: ResponseEntity[];
    selectedPollId: string;
    getPollChoisesList: (selectedPollId: string) => Promise<ResponseEntity[] | void>;
    shouldHideVotesCount?: boolean;
}

const PollVotesList: React.FC<IProps> = ({ responses, getPollChoisesList, selectedPollId, shouldHideVotesCount }) => {
  const filteredResponses = sortByOrder(responses);
  const percentages = calculatePollPercentages(filteredResponses.map(el => el.count || 0));

  useEffect(() => {
    if (!filteredResponses.length) getPollChoisesList(selectedPollId);
  }, [filteredResponses.length]);

  return (
    <div className='poll-details-votes-container'>
      {filteredResponses.map((el, idx) => {
        return <PollResponseVotes key={el.pollChoiceId} response={el} percent={percentages[idx]} shouldHideVotesCount={shouldHideVotesCount}/>;
      })}
    </div>
  );
};

// observer is required, not cosmetic: the percentages below are derived from every response's
// `count`, so this component must track those reads to re-render when the live-vote subscription
// mutates them. Without it the counts update (PollResponseVotes observes them) but the
// percentages stay stale until a reload.
export default observer(PollVotesList);